/**
 * 判断是否为正数、负数、小数、0
 * @param rule
 * @param value
 * @param callback
 */
const checkNumber = (rule, value, callback) => {
  if (/^(\-|\+)?\d+(\.\d+)?$/.test(value)) {
    callback();
  }

  callback(new Error());
};

/**
 * 判断是否为0、正整数
 * @param rule
 * @param value
 * @param callback
 */
const checkInteger = (rule, value, callback) => {
  if (validateInputInteger(value)) {
    callback();
  }

  callback(new Error());
};
const validateInputInteger = (value) => {
  return /^\d+$/.test(value);
}
const validateInputNumber = (num, maxL = 9, can0 = false) => {
  if (!num && num !== 0) return false;

  if (isNaN(num)) return false;

  num = num.toString().trim();

  if (!can0 && num === "0") return false;

  const index = num.indexOf(".");

  if (index === 0) {
    return false;
  } else if (index === -1 && num.length > maxL) {
    return false;
  } else if (num.length > maxL + 1) {
    return false;
  }

  if (!/^\d{1,9}(\.?[0-9]{1,2})?$/.test(parseFloat(num))) {
    return false;
  }

  return true;
};

/**
 * 判断是否为正数，支持小数(最多两位小数)
 * @param maxL 长度限制(不包括小数点)
 * @param can0 0能否验证通过
 */
const checkDecimal = (maxL = 9,can0 = false) => (rule, value, callback) => {
  if (validateInputNumber(value,maxL,can0)) {
    callback();
  }

  callback(new Error());
};

/**
 * 判断是否有值
 * @param rule
 * @param value
 * @param callback
 */
const checkValuable = (rule, value, callback) => {
  if (value === 0 || value) {
    callback();
  }

  callback(new Error());
};

/**
 * 判断input是否有值
 * @param rule
 * @param value
 * @param callback
 */
const checkInputValuable = (rule, value, callback) => {
  if (typeof value === "number" || (typeof value === "string" && value.trim())) {
    callback();
  }

  callback(new Error());
};

/**
 * 判断单选select是否有值
 * @param rule
 * @param value
 * @param callback
 */
const checkSelectValuable = (rule, value, callback) => {
  if (value[0] || value[0] === 0) {
    callback();
  }

  callback(new Error());
};

/**
 *
 * @param maxL 最大长度
 * @param decL 小数位最大位数
 */
const checkDecimal1 = (maxL = 15,decL = 4,passNullVal) => (rule, value, callback) => {
  const reg = new RegExp(`^(?=([0-9]{1,${maxL}}$|[0-9]{1,${maxL-decL}}\\.))(0|[1-9][0-9]*)(\\.[0-9]{1,${decL}})?$`,"g");

  if (passNullVal && !value && value !== 0) {
    callback();
  }

  if (reg.test(value)) {
    callback();
  }

  callback(new Error());
};

/**
 * 判断验证手机号码
 * @param rule
 * @param value
 * @param callback
 */
const checkPhone = (rule, value, callback) => {

  if ((/^1(1|2|3|4|5|6|7|8|9|0)\d{9}$/.test(value))) {
    callback();
  }

  callback(new Error());
};


/**
 * 去空格判断是否存在
 * @param rule
 * @param value
 * @param callback
 */
const trimRequired = (rule, value, callback) => {

  value = value.trim();
  if (!value) {
    callback(new Error());
  }
  callback();
};

/**
 * -999999999.99~999999999.99，保留两位小数
 * @param rule
 * @param value
 * @param callback
 */
const moreNumberRet = (rule, value, callback) => {
  let reg = /^-?[0-9][0-9]{0,8}(.[0-9]{1,2})?$/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
/**
 * 0~999999999.99，保留两位小数
 * @param rule
 * @param value
 * @param callback
 */
const morePositiveNumberRet = (rule, value, callback) => {
  let reg = /^[0-9][0-9]{0,8}(.[0-9]{1,2})?$/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};

export {
  checkNumber,
  checkInteger,
  checkDecimal,
  checkValuable,
  checkInputValuable,
  checkSelectValuable,
  checkDecimal1,
  validateInputNumber,
  validateInputInteger,
  morePositiveNumberRet,
  checkPhone,
  trimRequired,
  moreNumberRet
};
